import { sendFeedback } from "../clients/feedbackClient";

export const submitFeedback = async (user_id, message) => {
  return await sendFeedback(user_id, message);
};
